import { BaseService } from '../BaseService'
import { httpClient } from '../HttpClient'
import PostSubscriptionRequestObject from '../request_objects/accounts/subscriptions/CreateSubscriptionRequest'

export class SubscriptionService implements BaseService {
  public END_POINT: string = 'csl'
  public VERSION: string = process.env.VUE_APP_LICENSING_VERSION
  public ENTITLEMENTS = 'entitlements'

  public async getEntitlementsByOrgId(organizationId: string): Promise<object> {
    return await httpClient.get(`${this.END_POINT}/${this.VERSION}/${this.ENTITLEMENTS}/${organizationId}`)
  }

  public async updateEntitlements(productLicense: PostSubscriptionRequestObject): Promise<object> {
    return await httpClient.put(`${this.END_POINT}/${this.VERSION}/${this.ENTITLEMENTS}`, productLicense)
  }
}
